import React from "react";
import styled from "styled-components";
import TagCategory from "./TagCategory";
import device from "../helpers/device";
import { hallImg } from "../assetManager";

export default function({ hallId, category, children, ...rest }) {
  return (
    <Title>
      <div className="hall">
        <img src={hallImg[hallId]} width="75" alt="" />
        <Tag category={category} />
      </div>
      <div className="text">{children}</div>
    </Title>
  );
}

const Title = styled.div`
  border-left: 4px solid #3f271e;
  padding-left: 12px;
  @media ${device.mobileL} {
    padding-left: 20px;
  }
  .text {
    font-size: 16px;
    font-weight: bold;
    @media ${device.mobileL} {
      font-size: 20px;
    }
  }
  .hall {
    position: relative;
    @media ${device.mobileL} {
      margin-bottom: 10px;
      img {
        width: 110px;
      }
    }
  }
`;

const Tag = styled(TagCategory)`
  position: absolute;
  right: 0;
  top: -3px;
`;
